module.exports = __webpack_public_path__ + "static/media/sample-icon.0992c2a1.svg";